import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
      {/* Hero Section */}
      <section style={{ 
        background: 'var(--bg-secondary)',
        padding: '80px 0',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Privacy Policy
          </h1>
          <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
            Last updated: December 2024
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Introduction
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                At The Eternal Care, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our clinic or use our services.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Information We Collect
              </h2>
              <p className="body-regular" style={{ marginBottom: '12px', lineHeight: '1.7' }}>
                We collect the following types of information:
              </p>
              <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Personal identification information (name, phone number, email address)
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Medical and dental health information
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Appointment and treatment history
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Payment and billing information
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                How We Use Your Information
              </h2>
              <p className="body-regular" style={{ marginBottom: '12px', lineHeight: '1.7' }}>
                Your information is used for:
              </p>
              <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Providing and improving dental care services
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Scheduling and managing appointments
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Communicating about treatments and follow-up care
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Processing payments and maintaining records
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Data Security
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Your medical records are stored securely and accessed only by authorized personnel.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Your Rights
              </h2>
              <p className="body-regular" style={{ marginBottom: '12px', lineHeight: '1.7' }}>
                You have the right to:
              </p>
              <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Access your personal and medical information
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Request corrections to your information
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Request deletion of your data (subject to legal requirements)
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Withdraw consent for data processing
                </li>
              </ul>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Contact Us
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us at:
              </p>
              <p className="body-regular" style={{ marginBottom: '8px' }}>
                Email: theeternalcare@gmail.com
              </p>
              <p className="body-regular">
                Phone: +91 9256480329
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
